import { formatCurrency } from '@helpers/currency';
import * as React from 'react';
import S from './ExampleTable.styles';
const ExampleTable = (props) => {
    let loanPeriod = props.loanPeriod;
    if (props.deferralPeriod) {
        loanPeriod = props.loanPeriod - props.deferralPeriod;
    }
    return (React.createElement(S.Container, null,
        React.createElement(S.TitleWrapper, null,
            React.createElement(S.Title, null, props.title),
            props.showMonthly && React.createElement(S.Subtitle, null, props.subtitle)),
        React.createElement(S.DataTable, null,
            React.createElement("dt", null, "Cash Price:"),
            React.createElement("dd", null, formatCurrency(props.cashPrice)),
            React.createElement("dt", null, "Deposit:"),
            React.createElement("dd", null, formatCurrency(props.deposit)),
            React.createElement("dt", null, "Amount borrowed:"),
            React.createElement("dd", null, formatCurrency(props.borrowed)),
            React.createElement("dt", null, "Loan period:"),
            React.createElement("dd", null,
                props.loanPeriod,
                " months"),
            !!props.deferralPeriod && (React.createElement(React.Fragment, null,
                React.createElement("dt", null,
                    props.deferralPeriod,
                    " month deferral period"),
                React.createElement("dd", null))),
            React.createElement("dt", null, "Interest rate:"),
            React.createElement("dd", null,
                props.apr,
                "% p.a fixed"),
            React.createElement("dt", null, "Representative APR:"),
            React.createElement("dd", null,
                props.apr,
                "%"),
            React.createElement("dt", null,
                loanPeriod,
                " monthly repayments of:"),
            React.createElement("dd", null, formatCurrency(props.repayment)),
            React.createElement("dt", null, "Total payable (inc. deposit):"),
            React.createElement("dd", null, formatCurrency(props.totalPayable)),
            !!props.earlySettlementFee && (React.createElement(React.Fragment, null,
                React.createElement("dt", null, "Early settlement fee:"),
                React.createElement("dd", null, formatCurrency(props.earlySettlementFee)))))));
};
export default ExampleTable;
